module.exports = __webpack_public_path__ + "img/fangan_banner.bb31dcfd.png";